import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import UserSelect from './userSelect';

export default function router({ locales, users }) {
  return (
    <Router>
      <Switch>
        <Route path="*">
          <UserSelect locales={locales} users={users} />
        </Route>
      </Switch>
    </Router>
  );
}
